import Vue from 'vue';

// fontawesome svg
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars, faArrowLeft, faArrowRight, faChevronUp, faCaretUp, faCaretDown, faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { faFacebookSquare, faTwitter, faLinkedin, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faBars, faArrowLeft, faArrowRight, faChevronUp, faCaretUp, faCaretDown, faFileDownload, faFacebookSquare, faTwitter, faLinkedin, faInstagram);
Vue.component('font-awesome-icon', FontAwesomeIcon);